import { ApiResponse, fetchApi } from './common';
import { Appointment, AppointmentStatus, DoctorSchedule, DoctorScheduleTemplate } from './model';

// 创建预约请求接口
export interface CreateAppointmentRequest {
  patient_id: string;
  doctor_schedule_id: string;
  description: string;
}

// 查询预约请求接口
export interface ListAppointmentsRequest {
  start_time: string;
  end_time?: string;
  status_list?: AppointmentStatus[];
  schedule_location_id?: string | null;
}

// 预约API请求函数
export const appointmentApi = {
  // 医生替患者创建预约
  createAppointment: async (data: CreateAppointmentRequest): Promise<ApiResponse<Appointment>> => 
    fetchApi<Appointment>('/api/doctor_view/appointments', 'POST', data),

  // 确认预约
  confirmAppointment: async (id: string): Promise<ApiResponse<null>> => 
    fetchApi<null>(`/api/doctor_view/appointments/${id}/confirm`, 'POST'),

  // 拒绝预约
  rejectAppointment: async (id: string): Promise<ApiResponse<null>> => 
    fetchApi<null>(`/api/doctor_view/appointments/${id}/reject`, 'POST'),

  // 获取预约列表
  listAppointments: async (params: ListAppointmentsRequest): Promise<ApiResponse<Appointment[]>> => {
    // 处理schedule_location_id参数，如果是null则不传递
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key as keyof ListAppointmentsRequest];
      if (value !== undefined && value !== null) {
        if (key === 'schedule_location_id') {
          // 对于schedule_location_id，如果是null则不添加到查询参数中
          if (value !== null) {
            searchParams.append(key, value.toString());
          }
        } else if (key === 'status_list' && Array.isArray(value)) {
          // 处理status_list数组
          value.forEach(status => {
            searchParams.append('status_list', status.toString());
          });
        } else {
          searchParams.append(key, value.toString());
        }
      }
    });
    
    const queryString = searchParams.toString();
    return fetchApi<Appointment[]>(`/api/doctor_view/appointments${queryString ? `?${queryString}` : ''}`, 'GET');
  }
};